export enum PaymentType {
  Waiting = 'waiting',
  Paid = 'paid',
  Failed = 'failed',
  Cancelled = 'cancelled',
}
